// **********
// Return Window Width
// **********

function windowWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

const scrollToDiv = (element, scrollBehavior) => {
  const elementRect = element.getBoundingClientRect();
  const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
  const topOffset = elementRect.top + scrollTop;
  window.scrollTo({
    top: topOffset + 1,
    behavior: scrollBehavior,
  });
};
